module.exports = __webpack_public_path__ + "a8f9e656263bba56c9a4cae0f3d3654b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/star-half-filled.svg
// module id = 2532
// module chunks = 0